import { IconName, Illustration } from '@klp/design/Illustrations';
import { IconButton } from '@material-ui/core';
import React from 'react';
import { useKostnadsKalkyleContext } from '../kostnadskalkyle/context/KostnadsKalkyleProvider';
import { isAutoCalculatedDelsum } from './isAutoCalculatedDelsum';

type LonnsomhetTableRowActionsProps = {
    id: number | undefined;
    index: number;
    navn: string;
    onRemove: () => void;
};
export const LonnsomhetTableRowActions: React.FC<
    LonnsomhetTableRowActionsProps
> = ({ index, navn, onRemove }) => {
    const { isReadOnly } = useKostnadsKalkyleContext();

    if (isAutoCalculatedDelsum(index, navn) || isReadOnly) return null;

    return (
        <div>
            {!isReadOnly && (
                <IconButton onClick={onRemove} color="primary">
                    <Illustration
                        icon={IconName.DELETE}
                        klpPalette="primary"
                        klpColor="main"
                    />
                </IconButton>
            )}
        </div>
    );
};
